import { render, staticRenderFns } from "./Data2Chart.vue?vue&type=template&id=f4cb70c6&scoped=true&"
import script from "./Data2Chart.vue?vue&type=script&lang=js&"
export * from "./Data2Chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cb70c6",
  null
  
)

export default component.exports